<script>
import TalkizyAPI from '@app/services/API/Talkizy';
import CustomerPageVisioCard from '@app/components/CustomerPageVisioCard.vue';

export default {
  components: {
    CustomerPageVisioCard,
  },
  data: () => ({
    isFetching: false,
    hasError: false,
    participations: [],
    visioIndex: 0,
  }),
  computed: {
    isTalkizyConnected() {
      return this.$store.getters['auth/isTalkizyConnected'];
    },
    currentCustomer() {
      return this.$store.state.customers.current;
    },
    visiosLength() {
      return this.participations.length;
    },
  },
  methods: {
    load() {
      const email = this.currentCustomer && this.currentCustomer.email;

      if (!this.isTalkizyConnected || !email) {
        return;
      }

      this.isFetching = true;
      this.hasError = false;
      TalkizyAPI.getLearnerParticipations(email)
        .then((data) => {
          this.participations = (data && data.participations) || [];
          this.visioIndex = 0;
        })
        .catch(() => (this.hasError = true))
        .finally(() => (this.isFetching = false));
    },
  },
  watch: {
    'currentCustomer.email': function() {
      this.load();
    },
  },
  created() {
    this.load();
  },
};
</script>

<template>
  <section v-if="isTalkizyConnected && !hasError">
    <header class="mb-3">
      <div
        class="
          is-flex is-justify-content-space-between is-flex-wrap-wrap
          is-align-items-center mb-3
        "
      >
        <h2 class="title is-4 mr-5 mb-2">
          Classes virtuelles
        </h2>
      </div>
      <nav
        v-if="visiosLength > 1"
        class="buttons is-right"
      >
        <b-button
          type="is-text"
          size="is-small"
          icon-left="chevron-left"
          :disabled="visioIndex <= 0"
          @click="visioIndex--"
        >
          <span class="tdecoration-underline">Précédente</span>
        </b-button>
        <b-button
          type="is-text"
          size="is-small"
          icon-right="chevron-right"
          :disabled="visioIndex >= visiosLength - 1"
          @click="visioIndex++"
        >
          <span class="tdecoration-underline">Suivante</span>
        </b-button>
      </nav>
    </header>
    <b-skeleton v-if="isFetching" height="200" />
    <template v-else-if="visiosLength > 0">
      <CustomerPageVisioCard
        v-for="(one, i) in participations"
        :key="one.meeting_id"
        v-show="visioIndex == i"
        class="mb-5"
        :participation="one"
      />
    </template>
    <p v-else class="box is-info">
      Cet apprenant n'a participé à aucune classe virtuelle.
    </p>
  </section>
</template>
